import styled from 'styled-components';

export const TextAreaWrapper = styled.div`
	margin-bottom: ${({ marginBottom }) => marginBottom}rem;
`;

export const FormError = styled.span`
	display: block;
	margin-top: 1rem;
	font-size: 1.2rem;
	color: ${({ theme }) => theme.palette.error};
	text-align: left;
	padding-left: 0.7rem;
`;
